import type { Node } from '@tiptap/pm/model';
import type { EditorState } from '@tiptap/pm/state';

import { Node_Type } from './../../ricos-schema/legacy/wix/rich_content/v1';

export const isInsideList = (state: EditorState) => {
  let listNode = false;

  const { from, to } = state.selection;

  state.doc.nodesBetween(from, to, (node: Node) => {
    if (
      node.attrs.id &&
      [Node_Type.ORDERED_LIST, Node_Type.BULLETED_LIST].includes(node.type.name as Node_Type)
    ) {
      listNode = true;
    }
  });

  return listNode;
};
